<style scoped>
img {
  width:60%

}

</style>

<template>
  <v-stepper 
    v-model="step" 
    style="height:100%;overflow-y:scroll;max-width:100%;margin-right:1rem;" 
    class="elevation-0" 
    alt-labels
  >
    <v-stepper-header>
      <v-stepper-step :complete="e1 > 1" step="1">Register Device</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step :complete="e1 > 2" step="2">Create api-key</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step  step="3">Send data</v-stepper-step>
      <v-divider></v-divider>
    </v-stepper-header>

    <v-stepper-items class="subheading text-xs-left">
      <v-btn fab dark color="#FFD300" style="color:#002052;position:absolute;right:0;margin-top:1.5rem;z-index:10" @click="step++; step = (step==4)?1:step">
        <v-icon dark>fast_forward</v-icon>
      </v-btn>
      <v-btn fab dark color="#FFD300" style="color:#002052;position:absolute;right:0;bottom:0;z-index:10" @click="step++; step = (step==4)?1:step">
        <v-icon dark>fast_forward</v-icon>
      </v-btn>

      <v-stepper-content step="1">
        <v-card>
          <v-card-title   style="background-color:#39a9dc">
            <v-icon
              class="mr-3"
              dark
              size="42"
            >
              mdi-email-outline
            </v-icon>
            <h2 class="title white--text font-weight-light">Register device</h2>
          </v-card-title>
          <v-container>
            <v-layout row wrap>
                <v-flex xs12 >
                  Register device with:
                  <ul>
                    <li>human-friendly label</li>
                    <li>unique ID</li>
                  </ul>
                </v-flex>
                <v-flex>
                  <img style="" src="@/assets/howto/httpcreatedevice.png" />
                </v-flex>
              </v-layout>
          </v-container>
        </v-card>
      </v-stepper-content>


      <v-stepper-content step="2">
        <v-card>
          <v-card-title   style="background-color:#39a9dc">
            <v-icon
              class="mr-3"
              dark
              size="42"
            >
              mdi-email-outline
            </v-icon>
            <h2 class="title white--text font-weight-light">Create api-key</h2>
          </v-card-title>
          <v-container>
            <v-layout row wrap>
                <v-flex xs12 >
                  Create a new api-key from settings
                  <a v-on:click="$emit('routing', 'settings')">settings</a> 
                  view
                </v-flex>
                <v-flex xs12 style="text-align:center">
                  <img style="" src="@/assets/howto/assettrackingapikey.png" />
                </v-flex>
              </v-layout>
          </v-container>
        </v-card>
      </v-stepper-content>

      <v-stepper-content step="3">
        <v-card>
          <v-card-title  style="background-color:#39a9dc">
            <v-icon
              dark
              size="42"
              class="mr-3"
            >
              mdi-magnify
            </v-icon>
            <h2 class="title white--text font-weight-light">Send data</h2>
          </v-card-title>
          <v-container>
            <v-layout row wrap>
                  <v-flex xs12>
                    Send HTTP request with telemetry data:
                    <ul>
                      <li>URL: <a>https://{{http.host}}/{{http.basePath}}/telemetry</a></li>
                      <li>Authorization header set equal to <b>asset-tracking api-key</b> previously created </li>
                      <li>Content-type header set to <code>application/json</code> </li>
                      <li>Example body:
                          <div>
                          <code>
                          {"device_id":"1234",
                          "values":[
                            {"ts":1610623336479,"t":"temp","v": 25.52},
                            {"ts":1610623336479,"t":"hum","v": 80.1},
                            {"ts":1610623336490,"t":"pre","v": 1000},
                            {"ts":1610623336490,"t":"acc","v": { "x": 0.1, "y": 0.1, "z": 0.1 }},
                            {"ts":1610623336490,"t":"gyr","v": { "x": 0.1, "y": 0.1, "z": 0.1 }},
                            {"ts":1610623336490,"t":"mag","v": { "x": 0.1, "y": 0.1, "z": 0.1 }}
                          ]
                          </code>
                          </div>
                      </li>
                    </ul>
                  </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-stepper-content>

    </v-stepper-items>
  </v-stepper>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(
      {
          http: state => state.metadata.backendApi.http[state.metadata.env]
      }
    )
  },
  data(){
    return {
      step: 0
    }
  }
}
</script>